export default __webpack_public_path__ + "static/media/Turtlr-gameplay-screenshot-450px-300px.4e693f29.jpg";